<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-12-tablet is-2-desktop">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Projects</span>
                        <a
                                v-if="! isView"
                                href="#"
                                class="gear"
                                @click.prevent="isTableSettingsModalActive = true"
                        >
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                        <a
                                v-if="isView && currentTableView && canEditView(currentTableView.id)"
                                href="#"
                                class="gear"
                                @click.prevent="openCustomViewModal(currentTableView.id)"
                        >
                            <o-icon pack="fa" icon="edit" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.name"
                        placeholder="Project Name / Number"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                        v-model="filters.companyId"
                        type="company"
                        field-name="name"
                        placeholder="Search by Company"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                        v-model="filters.assignedTo"
                        placeholder="Project Manager"
                        type="user"
                        field-name="full_name"
                    />
                </o-field>
            </div>
            <div class="column is-4-desktop">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="openCustomViewModal(null)" class="button is-info"><span>Create Custom View</span></a>
                    </p>
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="handleResetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns is-desktop toolbar-box">
            <div class="column is-4-tablet is-2-desktop"></div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-select
                            v-model="filters.status"
                            :expanded="true"
                            placeholder="Select a Status"
                            @input="fetchPaginatedData(true)"
                    >
                        <option value="">Select a Status</option>
                        <option
                            v-for="status in projectStatuses"
                            :value="status.id"
                            :key="status.id"
                        >
                            {{ status.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                        v-model="filters.building"
                        type="search"
                        placeholder="Building"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                        v-model="filters.street"
                        type="search"
                        placeholder="Street"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
        </div>
        <div class="columns is-desktop toolbar-box">
            <div class="column is-4-tablet is-2-desktop"></div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-select
                            v-model="filters.project_type"
                            :expanded="true"
                            placeholder="Select a Type of Project"
                            @input="fetchPaginatedData(true)"
                    >
                        <option value="">Select a Type of Project</option>
                        <option
                            v-for="projectType in projectTypes"
                            :value="projectType.id"
                            :key="projectType.id"
                        >
                            {{ projectType.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <o-checkbox
                        @input="fetchPaginatedData(true)"
                        v-model="filters.notable">
                        Is Notable
                    </o-checkbox>
                </div>
            </div>        
        </div>
        <custom-views-filter
                :view-id-prop="filters.table_view_id"
                type="projects"
                @input="changeCustomView"
        >
            <template v-slot:siblings>
                <div class="column is-4-tablet is-4-desktop">
                    <multicomplete v-model="applicationIds" :optionsProp="applicationsOptions" @input="handleApplicationIdsSelected" @search-changed="handleApplicationIdsChange" type="custom" placeholder="Application id" />
                </div>
            </template>
        </custom-views-filter>

        <o-table
            class="fullwidth-table is-responsive is-responsive-hd"

            v-if="(!isView || (isView && currentTableView)) && isTableVisible"
            :data="paginatedData"

            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                        :field="col.field"
                        :label="col.field === 'actions' ? '' : col.label"
                        v-for="col in tableColumns"
                        v-bind="col"
                        #default="{ row }"
                    >
                        <project-column v-if="col.field !== 'actions'" :field="col.field" :item="row" />

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                            <template class="button" v-slot:trigger="trigger">
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </template>
                            <o-dropdown-item has-link><router-link :to="{ name: 'projects.show', params: { slug: row.id } }">View Project</router-link></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openReplyModal(row.id)">Reply</a></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openReminderModal(row.id)">Set Reminder</a></o-dropdown-item>
                            <o-dropdown-item has-link v-if="isFollowed(row.id)"><a @click.prevent="unfollow(row)">Unfollow</a></o-dropdown-item>
                            <o-dropdown-item has-link v-else><a @click.prevent="follow(row)">Follow</a></o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <total
                :is-filtered="isResetFiltersButtonVisible"
                :total-amount="projectsTotal"
                :filtered-amount="total"
        />

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="projectId" reference-type="project"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReplyModalActive" has-modal-card>
            <reply-modal :reference-id="projectId" reference-type="project"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCustomViewModalActive" has-modal-card>
            <custom-view-modal
                    :custom-view="customViewToEdit"
                    @custom-view-created="filters.table_view_id = $event"
                    @custom-view-deleted="filters.table_view_id = null"
            />
        </o-modal>
    </div>
</template>

<script>
    import ProjectColumn from './../../components/table-columns/Project'
    import SupportsCustomViews from './../../mixins/SupportsCustomViews'
    import Total from './../../components/Total'
    import {mapActions, mapGetters} from 'vuex'
    import Table from './../../mixins/Table'

    export default {
        components: {
            ProjectColumn, Total
        },

        mixins: [Table, SupportsCustomViews],

        data () {
            return {
                applicationsOptions: [],
                applicationIds: [],
                filters: {},
                tableName: 'projects-index',
                isReminderModalActive: false,
                isReplyModalActive: false,
                projectId: null,
                activeTab: 0,
            }
        },

      computed: {
            ...mapGetters([
                'appIsHydrated',
                'userNameById',
                'boroughs',
                'boroughNameById',
                'projectStatuses',
                'isFollowed',
                'latestNoteMessageByProjectId',
                'projectsTotal',
                'projectTypes'
            ]),

            ...mapGetters({
                itemsByIds: 'projectsByIds'
            })
        },

        created () {
            this.applicationIds = []
            this.filters = {
                applicationIds: [],
                name: '',
                status: '',
                building: '',
                street: '',
                companyId: '',
                assignedTo: '',
                table_view_id: null,
            }
        },

        methods: {
            ...mapActions({
                fetchApplicationsByIds: 'fetchApplicationsByIds',
                fetchData: 'fetchProjects',
                removeItem: 'removeProject'
            }),

            ...mapActions([
                'fetchTableViewById',
                'updateFollowedProject',
            ]),

            follow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are following this project now')
                })
            },

            handleApplicationIdsChange(applicationId) {
                if(!applicationId) return
                this.fetchApplicationsByIds({ applicationId }).then(res=>{
                        const { data = [] } = res.data
                        data.map(i => {
                            i.label = i.type + ' - ' + i.applicationId
                        })
                        // this.$set(this, 'applicationsOptions', data)
                        this.applicationsOptions = data
                })
            },

            handleApplicationIdsSelected() {
                this.filters.applicationIds = this.applicationIds.map(i=> ({ id: i.id, type: i.type }))
                this.fetchPaginatedData(true)
                this.applicationsOptions = []
            },
            
            handleResetFilters() {
                this.resetFilters()
                this.applicationsOptions = []
                this.applicationIds = []
            },

            unfollow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are not following this project anymore')
                })
            },

            openReminderModal (projectId) {
                this.isReminderModalActive = true
                this.projectId = projectId
            },

            openReplyModal (projectId) {
                this.isReplyModalActive = true
                this.projectId = projectId
            }
        },

        watch:{
          "filters.companyId"(value){
            this.fetchPaginatedData(true)
          },

          "filters.assignedTo"(value){
            this.fetchPaginatedData(true)
          },
        }
    }
</script>